/**
 * View component for /profile
 *
 * Display logged in user's own profile information and lets them update if
 * they want.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import third-party libraries
import classNames from 'classnames';
import moment from 'moment';

// import actions
import * as userActions from '../userActions';
import * as userEventActions from '../../userEvent/userEventActions';

// import global components
import AlertModal from '../../../global/components/modals/AlertModal.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";

// import user components
import UserProfileLayout from '../components/UserProfileLayout.js.jsx';
import { PasswordInput } from '../../../global/components/forms';

class ChangePassword extends Base {
  constructor(props) {
    super(props);
    this.state = {
      oldPass: ""
      , newPass: ""
      , newPassConfirm: ""
      , errorMessage: ""
      , errorModalOpen: false
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
      , '_closeModal'
    );
  }

  _closeModal() {
    this.setState({
      errorModalOpen: false
      , errorMessage: ""
    })
  }

  _handleFormChange(e) {

    this.setState({
      [e.target.name]: e.target.value
    })
  }

  _handleFormSubmit(e) {
    console.log("DO STUFF")
    const { dispatch } = this.props;
    const { oldPass, newPass, newPassConfirm } = this.state;

    dispatch(userActions.sendUpdatePassword({
      oldPass, newPass, newPassConfirm
    })).then(res => {
      if(res.success) {
        this.props.history.push('/user/profile');
      } else {
        // show error modal
        console.log("error state", res)
        this.setState({
          oldPass: ""
          , newPass: ""
          , newPassConfirm: ""
          , errorMessage: res.error
          , errorModalOpen: true
        })
      }
    })
  }


  render() {
    const { oldPass, newPass, newPassConfirm } = this.state;

    return (
      <UserProfileLayout>
        <Helmet
          title={"Change Password | Pro-ficiency"}
        />
        <div className="flex ">
          <section className="section ">
            <div className="yt-container">
              <div className="yt-row with-gutters ">
                <div className="yt-col full l_50">
                  {/* <button className="yt-btn small u-pullRight" onClick={this._openUpdateModal}>Update Profile</button> */}
                  <h1>Change Your Password </h1>
                  <h4>Your password must contain at least 8 characters and one each of: uppercase, lowercase, number, and special character.</h4>
                  <hr/>
                  <PasswordInput
                    name="oldPass"
                    label="Current Password"
                    value={oldPass}
                    change={this._handleFormChange}
                    required={true}
                  />
                  <PasswordInput
                    name="newPass"
                    label="New Password"
                    value={newPass}
                    change={this._handleFormChange}
                    required={true}
                  />
                  <PasswordInput
                    name="newPassConfirm"
                    label="Confirm New Password"
                    value={newPassConfirm}
                    change={this._handleFormChange}
                    required={true}
                  />

                  <button 
                    type="button"
                    className="yt-btn danger"
                    disabled={newPass.length == 0 || newPass !== newPassConfirm}
                    onClick={this._handleFormSubmit}>
                      Save
                  </button>

                </div>
              </div>
            </div>
          </section>
          <AlertModal
            alertMessage={this.state.errorMessage}
            alertTitle="Error With Password Change"
            closeAction={this._closeModal}
            confirmAction={this._closeModal}
            confirmText="Try again"
            // declineText="Reset Password"
            // declineAction={this._goToResetPass}
            isOpen={this.state.errorModalOpen}
            type="danger"
          />
        </div>
      </UserProfileLayout>
    )
  }
}

ChangePassword.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  return {
    user: store.user.loggedIn.user
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(ChangePassword)
);



// WEBPACK FOOTER //
// modules/user/views/ChangePassword.js.jsx